import { useEffect, useState } from "react";
import { sideBarByRoleId } from "../../../services/sideBar";

const Permission = ({selectedPermissions,setSelectedPermissions}) => {
  const [menuData, setMenuData] = useState([]);
  //const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [loading, setLoading] = useState(false);

  const roleId = localStorage.getItem("roleid");

  // Fetch Menus
  useEffect(() => {
    const fetchMenus = async () => {
      if (!roleId) return;

      setLoading(true);

      try {
        const response = await sideBarByRoleId(roleId);

        if (response?.statusCode === 200 && response?.success) {
          setMenuData(response.data);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchMenus();
  }, [roleId]);

  // Handle single checkbox
  // const handleCheckbox = (permissionId) => {
  //   setSelectedPermissions((prev) =>
  //     prev.includes(permissionId)
  //       ? prev.filter((item) => item !== permissionId)
  //       : [...prev, permissionId]
  //   );
  // };
const handleCheckbox = (permissionId) => {
  setSelectedPermissions((prev) =>
    prev.includes(permissionId)
      ? prev.filter((item) => item !== permissionId)
      : [...prev, permissionId]
  );
};
  // // Handle Select All per title
  // const handleSelectAll = (submenu, checked, menuIndex) => {
  //   const submenuIds = submenu.map(
  //     (_, subIndex) => `${submenu.id}`
  //   );

  //   if (checked) {
  //     // Add all submenu ids
  //     setSelectedPermissions((prev) => [
  //       ...new Set([...prev, ...submenuIds]),
  //     ]);
  //   } else {
  //     // Remove all submenu ids
  //     setSelectedPermissions((prev) =>
  //       prev.filter((id) => !submenuIds.includes(id))
  //     );
  //   }
  // };

  const handleSelectAll = (submenu, checked) => {
  const submenuIds = submenu.map((item) =>
    Number(item.id)
  );

  if (checked) {
    setSelectedPermissions((prev) => [
      ...new Set([...prev, ...submenuIds]),
    ]);
  } else {
    setSelectedPermissions((prev) =>
      prev.filter((id) => !submenuIds.includes(id))
    );
  }
};

  // // Check if all submenu selected
  // const isAllSelected = (submenu, menuIndex) => {
  //   const submenuIds = submenu.map(
  //     (_, subIndex) => `${submenu.id}`
  //   );

  //   return submenuIds.every((id) =>
  //     selectedPermissions.includes(id)
  //   );
  // };
  const isAllSelected = (submenu) => {
  const submenuIds = submenu.map((item) =>
    Number(item.id)
  );

  return (
    submenuIds.length > 0 &&
    submenuIds.every((id) =>
      selectedPermissions.includes(id)
    )
  );
};
  return (
    <div className="card shadow">
      <div className="card-header bg-primary text-white">
        <h4 className="mb-0">Permission Management</h4>
      </div>

      {loading && <p className="p-3">Loading...</p>}

      <div className="card-body">
        {menuData.map((menu, menuIndex) => (
          <div key={menuIndex} className="mb-4">

            {/* Title + Select All */}
            <div className="d-flex align-items-center mb-2">
              <h5 className="text-primary me-3 mb-0">
                {menu.title}
              </h5>

              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={`select-all-${menuIndex}`}
                  checked={isAllSelected(menu.submenu, menuIndex)}
                  onChange={(e) =>
                    handleSelectAll(
                      menu.submenu,
                      e.target.checked,
                      menuIndex
                    )
                  }
                />

                <label
                  className="form-check-label"
                  htmlFor={`select-all-${menuIndex}`}
                >
                  Select All
                </label>
              </div>
            </div>

            {/* Submenus */}
            <div className="row">
              {menu.submenu.map((item, subIndex) => {
                const permissionId = Number(item.id);//`${item.id}`;

                return (
                  <div
                    className="col-md-5 mb-3"
                    key={permissionId}
                  >
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`permission-${permissionId}`}
                        checked={selectedPermissions.includes(
                          permissionId
                        )}
                        onChange={() =>
                          handleCheckbox(permissionId)
                        }
                      />

                      <label
                        className="form-check-label"
                        htmlFor={`permission-${permissionId}`}
                      >
                        {item.name}
                      </label>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Permission;